import classNames from 'classnames'
import arrowForward from '../../../../assets/arrow_forward.svg'
import { VIRTUAL_TOUR_TABS } from '../../constant'
import './styles.scss'
import { useTranslation } from 'react-i18next'

// Component for phone screens
const InteriorController = ({ activeTab, setTab, index, count, onClick }) => {
  const { t } = useTranslation()
  return (
    <div className="interior-controller">
      {/* Style modified TourController */}
      <div className="interior-tour-controller">
        <div className="interior-tour-controller-tab-container">
          <button
            className={classNames({
              'interior-tour-controller-tab-button': true,
              'interior-tour-controller-tab-button--active':
                activeTab === VIRTUAL_TOUR_TABS.INTERIOR,
            })}
            onClick={() => setTab(VIRTUAL_TOUR_TABS.INTERIOR)}
            disabled={activeTab === VIRTUAL_TOUR_TABS.INTERIOR}
          >
            {t('tourController.interior')}
          </button>
          <button
            className={classNames({
              'interior-tour-controller-tab-button': true,
              'interior-tour-controller-tab-button--active':
                activeTab === VIRTUAL_TOUR_TABS.EXTERIOR,
            })}
            onClick={() => setTab(VIRTUAL_TOUR_TABS.EXTERIOR)}
            disabled={activeTab === VIRTUAL_TOUR_TABS.EXTERIOR}
          >
            {t('tourController.exterior')}
          </button>
        </div>
      </div>

      {/* Style modified CarouselController */}
      <div className="interior-carousel-controller">
        <button
          type="button"
          onClick={() => onClick('prev')}
        >
          <img
            src={arrowForward}
            alt="Arrow backward"
            className="rotate-180"
          />
        </button>

        <div className="interior-carousel-controller-nav">
          <div className="interior-carousel-controller-counter">
            {index}/{count}
          </div>
          <div className="dots-container">
            {[...Array(count)].map((item, idx) => (
              <div
                key={idx}
                className={classNames({
                  dot: true,
                  'dot--active': idx + 1 === index,
                })}
                onClick={() => onClick(idx)}
              />
            ))}
          </div>
        </div>

        <button
          type="button"
          onClick={() => onClick('next')}
        >
          <img
            src={arrowForward}
            alt="Arrow forward"
          />
        </button>
      </div>
    </div>
  )
}

export default InteriorController
